<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Jane McLeod was born in 1960 in Auckland, New Zealand, where she has lived most of her life. The inspiration for <em>The Sex Coach</em> came from various conversations about separation with other women, all of whom described a difficult adjustment for family and friends, and some had experienced a period of sexual exploration and freedom. This is Jane’s first novel.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?62251445